import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchArticles = ({ category, featured, popular, limit, exclude } = {}) =>
  axios
    .get(`${API}/articles`, {
      params: { category, featured, popular, limit, exclude },
    })
    .then((r) => r.data);

export const fetchArticleBySlug = (slug) =>
  axios.get(`${API}/articles/${slug}`).then((r) => r.data);

export const fetchArticleCategories = () =>
  axios.get(`${API}/articles/categories`).then((r) => r.data);

export const searchArticles = (q, limit = 20) =>
  axios
    .get(`${API}/articles/search`, { params: { q, limit } })
    .then((r) => r.data);
